import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { colorsFoundation } from "../../../theme/index.js";

const ACCENT = "#4A78BC";

/**
 * Read-only summary for the schmidt broker "Prüfen & Senden" step. Renders the
 * placed wizard fields grouped into sections (label → value), matching the
 * dummy's grouped `fullRecap`. Falls back to a flat `item.fields` list.
 */
function formatValue(v) {
  if (v === true) return "Ja";
  if (v === false) return "Nein";
  if (Array.isArray(v)) return v.length ? `${v.length} Einträge` : "–";
  if (v === null || v === undefined || v === "") return "–";
  return String(v);
}

const hasValue = (v) =>
  v !== null && v !== undefined && v !== "" && v !== false;

function Row({ label, value }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        gap: "20px",
        py: "7px",
        borderBottom: `1px solid ${colorsFoundation.gray[100]}`,
      }}
    >
      <Typography sx={{ fontSize: "12.5px", color: colorsFoundation.gray[500], flex: "none" }}>
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: "12.5px",
          fontWeight: 600,
          color: colorsFoundation.gray[900],
          textAlign: "right",
        }}
      >
        {formatValue(value)}
      </Typography>
    </Box>
  );
}

Row.propTypes = { label: PropTypes.string, value: PropTypes.any };

export default function ClaimRecap({ item, values = {} }) {
  // Prefer grouped sections; fall back to a flat field list.
  const sections =
    item?.sections && item.sections.length
      ? item.sections
      : [{ title: null, rows: item?.fields || [] }];

  // Keep only sections that have at least one filled field.
  const visibleSections = sections
    .map((s) => ({
      title: s.title,
      rows: (s.rows || []).filter((r) => hasValue(values[r.name])),
    }))
    .filter((s) => s.rows.length > 0);

  return (
    <Box
      sx={{
        border: `1px solid ${colorsFoundation.gray[200]}`,
        borderRadius: "12px",
        p: "4px 18px 14px",
        backgroundColor: colorsFoundation.gray[50],
        width: "100%",
      }}
    >
      {visibleSections.length === 0 ? (
        <Typography
          sx={{ fontSize: "13px", color: colorsFoundation.gray[500], py: "12px" }}
        >
          Noch keine Angaben erfasst.
        </Typography>
      ) : (
        visibleSections.map((s) => (
          <Box key={s.title || "flat"}>
            {s.title && (
              <Typography
                sx={{
                  fontSize: "11px",
                  fontWeight: 700,
                  letterSpacing: "0.09em",
                  textTransform: "uppercase",
                  color: ACCENT,
                  mt: "16px",
                  mb: "4px",
                }}
              >
                {s.title}
              </Typography>
            )}
            {s.rows.map((r) => (
              <Row key={r.name} label={r.label} value={values[r.name]} />
            ))}
          </Box>
        ))
      )}
    </Box>
  );
}

ClaimRecap.propTypes = {
  item: PropTypes.object,
  values: PropTypes.object,
};
